




















import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    mounted() {
        const tooltipTrigger = this.$el.querySelector("button")
        this.positionTooltip()
        tooltipTrigger.addEventListener('focus', function (e) {
            (e.target as HTMLElement).parentElement.classList.remove('close');
        });
        tooltipTrigger.addEventListener('mouseover', function (e) {
            (e.target as HTMLElement).parentElement.classList.remove('close');
        });
        tooltipTrigger.addEventListener('keydown', function (e) {
            if ((e.keyCode) === 27 || e.key === "Escape") (e.target as HTMLElement).parentElement.classList.add('close');
        });
    },
    methods: {
        positionTooltip() {
        const tooltipContent = this.$el.querySelector("[role='tooltip']")

            const bounding = tooltipContent.getBoundingClientRect();
            if (bounding.left < 0) {
                this.$el.classList.add("left")
            } else if (bounding.right >= window.innerWidth) {
                this.$el.classList.add("right")
            }
        }
    }
})
